import React, { useState, useEffect } from "react";
import { fetchWrapper } from "utils/apiFetch";

function BillPayment() {
  const [operators, setOperators] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [billData, setBillData] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);

  // Toast
  const showToast = (message, type = "primary") => {
    const alertDiv = document.createElement("div");
    alertDiv.className = `alert alert-${type} alert-dismissible position-fixed top-0 end-0 m-3 shadow`;
    alertDiv.style.zIndex = 2000;
    alertDiv.innerHTML = `
      <div class="d-flex justify-content-between align-items-center">
        <p class="mb-0 flex-grow-1">${message}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
      </div>`;
    document.body.appendChild(alertDiv);
    setTimeout(() => alertDiv?.remove(), 3000);
  };

  // Fetch Operators
  useEffect(() => {
    const fetchOperators = async () => {
      try {
        const res = await fetchWrapper("https://pro.mokshiq.in/fetch_bbps1_operator?userid=3");
        const json = res;
        if (json.data) {
          setOperators(json.data);
          const uniqueCategories = [
            ...new Set(json.data.map((op) => op.category).filter(Boolean)),
          ];
          setCategories(uniqueCategories);
        }
      } catch (err) {
        console.error("Error loading operators:", err);
      }
    };
    fetchOperators();
  }, []);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedOperator(null);
    setBillData(null);
    setFormValues({});
    setError("");
  };

  const handleOperatorChange = (e) => {
    const opName = e.target.value;
    const op = operators.find((o) => o.operatorName === opName);
    setSelectedOperator(op || null);
    setFormValues({});
    setBillData(null);
    setError("");
  };

  const handleInputChange = (key, value) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
  };

  const validateFields = () => {
    if (!selectedCategory) {
      setError("Please select a category");
      return false;
    }
    if (!selectedOperator) {
      setError("Please select an operator");
      return false;
    }
    if (!formValues.cn) {
      setError(`${selectedOperator.cn} is required`);
      return false;
    }
    return true;
  };

  const handleFetchBill = async () => {
    if (!validateFields()) return;
    setLoading(true);
    setError("");
    try {
      const fd = new FormData();
      fd.append("opid", selectedOperator.id);
      fd.append("userid", "3");
      fd.append("cn", formValues.cn || "");
      fd.append("ad1", formValues.ad1 || "");
      fd.append("ad2", formValues.ad2 || "");
      fd.append("ad3", formValues.ad3 || "");
      fd.append("ad4", formValues.ad4 || "");

      const res = await fetch("https://pro.mokshiq.in/fetch_bbps1_bill", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: fd,
      });
      const data = await res.json();
      
        setBillData(data.data);
        showToast(data.data, "success");
    //   } else {
    //     showToast(data.message || "Bill fetch failed", "danger");
    //     setBillData(null);
    //   }
    } catch (err) {
      console.error("Bill fetch error:", err);
      showToast("Error fetching bill", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handlePayBill = async () => {
    if (!billData) {
      showToast("Please fetch bill before payment", "warning");
      return;
    }
    setPaymentLoading(true);
    try {
      const fd = new FormData();
      fd.append("opid", selectedOperator.id);
      fd.append("userid", "3");
      fd.append("cn", formValues.cn || "");
      fd.append("ad1", formValues.ad1 || "");
      fd.append("ad2", formValues.ad2 || "");
      fd.append("ad3", formValues.ad3 || "");
      fd.append("ad4", formValues.ad4 || "");
      fd.append("amount", "10");
      fd.append("customerName", billData.customerName || "");

      const res = await fetch("https://pro.mokshiq.in/pay_bbps1_bill", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: fd,
      });
      const data = await res.json();

      if (data.status) {
        showToast(data.message || "Payment successful", "success");
        setSelectedOperator(null);
        setSelectedCategory("");
        setFormValues({});
        setBillData(null);
      } else {
        showToast(data.message || "Payment failed", "danger");
      }
    } catch (err) {
      console.error("Payment error:", err);
      showToast("Payment failed", "danger");
    } finally {
      setPaymentLoading(false);
    }
  };

  const renderInput = (label, key, pattern, dropdownOptions, isDropdown) => {
    if (!label) return null;
    if (isDropdown && Array.isArray(dropdownOptions)) {
      return (
        <div className="col-md-6 mb-3" key={key}>
          <label className="form-label">{label}</label>
          <select
            className="form-select"
            value={formValues[key] || ""}
            onChange={(e) => handleInputChange(key, e.target.value)}
            required
          >
            <option value="">-- Select --</option>
            {dropdownOptions.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.name}
              </option>
            ))}
          </select>
        </div>
      );
    }
    return (
      <div className="col-md-6 mb-3" key={key}>
        <label className="form-label">{label}</label>
        <input
          className="form-control"
          placeholder={`Enter ${label}`}
          value={formValues[key] || ""}
          onChange={(e) => handleInputChange(key, e.target.value)}
          required
          pattern={pattern || ".*"}
        />
      </div>
    );
  };

  const filteredOperators = operators.filter(
    (op) => op.category === selectedCategory
  );

  return (
    <main>
      <div className="container-fluid">
        <div className="row m-1">
          <div className="col-12">
            <h4 className="main-title">Bill Payment</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">Bill Payment</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              {(loading || paymentLoading) && (
                <div
                  className="page-loader-overlay d-flex justify-content-center align-items-center"
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    zIndex: 3000,
                  }}
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}

              <div className="card-body">
                <form className="app-form">
                  <div className="row">
                    {/* Category Dropdown */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Select Category</label>
                      <select
                        className="form-select"
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        required
                      >
                        <option value="">-- Select Category --</option>
                        {categories.map((cat, i) => (
                          <option key={i} value={cat}>
                            {cat}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Operator Dropdown (filtered by category) */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Select Operator</label>
                      <select
                        className="form-select"
                        value={selectedOperator?.operatorName || ""}
                        onChange={handleOperatorChange}
                        required
                        disabled={!selectedCategory}
                      >
                        <option value="">-- Select Operator --</option>
                        {filteredOperators.map((op, i) => (
                          <option key={i} value={op.operatorName}>
                            {op.operatorName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Dynamic Input Fields */}
                    {selectedOperator &&
                      renderInput(
                        selectedOperator.cn,
                        "cn",
                        null,
                        selectedOperator.dataViewDrop,
                        !selectedOperator.fieldType
                      )}
                    {selectedOperator &&
                      ["ad1", "ad2", "ad3", "ad4"].map((key) => {
                        const label = selectedOperator[key];
                        if (label) {
                          return renderInput(label, key);
                        }
                        return null;
                      })}
                  </div>

                  {error && <p className="text-danger">{error}</p>}

                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-light-primary m-2"
                      onClick={handleFetchBill}
                    >
                      Fetch Bill
                    </button>

                    {billData && (
                      <>
                        <p><strong>Customer:</strong> {billData.customerName}</p>
                        <p><strong>Amount:</strong> ₹{billData.amount}</p>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handlePayBill}
                        >
                          Pay Bill
                        </button>
                      </>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default BillPayment;
